import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryProvider } from './providers/QueryProvider'
import { AuthProvider } from './providers/AuthProvider'
import { ErrorBoundary } from './components/ui/error-boundary'
import App from './App'
import './index.css'
import 'leaflet/dist/leaflet.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(container)
root.render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <QueryProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
)
